import {
	type Component,
	defineComponent,
	h,
} from 'vue';
import CappedStackRoot from './index.vue';

function createCappedStackVariantComponent(
	name: string,
	maxVisible: number,
	stackAttrs: Record<string, unknown> = {},
): Component {
	return defineComponent({
		name,
		inheritAttrs: false,
		setup(_props, { attrs, slots }) {
			return () => h(
				CappedStackRoot as unknown as Component,
				{
					...attrs,
					...stackAttrs,
					maxVisible,
				},
				slots,
			);
		},
	});
}

export type * from './index.vue';

export { createCappedStackVariantComponent };

export { default } from './index.vue';
